import { ARC3D_NUMBER_TYPE } from "@visactor/vrender-core";

import { Base3dPicker } from "../common/base-3d-picker";

export class DefaultCanvasArc3dPicker extends Base3dPicker {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "arc3d", this.numberType = ARC3D_NUMBER_TYPE, 
        this.themeType = "arc";
    }
}
//# sourceMappingURL=arc3d-picker.js.map
